/**
 * @fileoverview Peças visuais compartilhadas pelos painéis das ferramentas de
 * Super Admin da conexão.
 */

import React from "react";
import { Check } from "lucide-react";

import useStyles from "./styles";
import { fmtNumber, isActiveStatus, t } from "./format";

export const CheckMark = ({ on }) => {
	const classes = useStyles();
	return (
		<span className={`${classes.check} ${on ? classes.checkOn : ""}`} aria-hidden="true">
			{on && <Check size={13} strokeWidth={3} />}
		</span>
	);
};

export const Stat = ({ value, label, sub }) => {
	const classes = useStyles();
	return (
		<div className={classes.stat}>
			<span className={classes.statValue}>{fmtNumber(value)}</span>
			<span className={classes.statLabel}>{label}</span>
			{sub ? <span className={classes.statSub}>{sub}</span> : null}
		</div>
	);
};

export const StatusBadge = ({ status }) => {
	const classes = useStyles();
	const active = isActiveStatus(status);
	const variant = active
		? classes.badgeActive
		: status === "completed"
			? classes.badgeDone
			: status === "failed" || status === "denied"
				? classes.badgeDanger
				: classes.badgeMuted;
	return (
		<span className={`${classes.badge} ${variant}`}>
			<span className={`${classes.badgeDot} ${active ? classes.badgeDotPulse : ""}`} aria-hidden="true" />
			{t(`statusLabel.${status}`)}
		</span>
	);
};
